<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-06-19 09:58:05
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-12 10:19:24
 * @FilePath: \seller.sviptrader.com\src\components\layout\ControlHeader.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="c-header">
			<div class="left-label">
				<div class="logo flex-row-align-center">
					<img :src="baseInfo.left_top_logo" alt="" class="mr-6" style="width: 28px; height: 28px; border-radius: 4px" />
					<span class="yx-color-text-primary fz-18 yx-pingfang-semibold">{{ baseInfo.company_name }}</span>
				</div>
				<top-menu class="ml-24"></top-menu>
			</div>
			<div class="right-label">
				<!-- 套餐版本标识 -->
				<!-- <div class="version radius-16 mr-12" :class="curVersionClass" v-if="curVersionClass">
					<i></i>
					{{ tenantInfo.packageName }}
				</div> -->

				<!-- 新手引导 -->
				<div
					class="radius-16 cursor-pointer flex-row-align-center mr-12 yx-border font-h6-regular yx-color-text-primary p-6 pb-6 pl-16 pr-16"
					@click="openGuide"
					v-if="tenantInfo.friendVersion"
				>
					<i class="i-guide"></i>
					<span class="ml-4">新手引导</span>
				</div>
				<!-- 客服 -->
				<customerQr v-if="tenantInfo.friendVersion" />

				<!-- 切换视角 -->
				<switch-view ref="switchView" @change="handleCommand" />
				<div class="user-info-wrapper" @mouseenter="userEnter" @mouseleave="userLeave">
					<!-- 用户信息（简版） -->
					<div class="user-info">
						<div class="user-name">
							<yx-avatar :src="userInfo.avatar" :size="32" class="mr-8"></yx-avatar>
							<div class="name-box mr-8">
								<span class="name">{{ vuex_sphExpoName || userInfo.nickname | formatEmpty | textFormat(6) }}</span>
							</div>
							<i class="el-icon-caret-bottom user-dropdown-array"></i>
						</div>
					</div>
					<transition name="el-zoom-in-top">
						<div class="dropdown radius-8 yx-background-white" v-show="isSwitch">
							<div class="flex-row-align-center pt-12 pr-16 pb-8 pl-16">
								<yx-avatar :src="userInfo.avatar" class="mr-8"></yx-avatar>
								<div>
									<div class="flex-row-align-center">
										<p class="yx-color-text-primary font-h4-regular">{{ vuex_sphExpoName || userInfo.nickname | formatEmpty | textFormat(7) }}</p>
									</div>
									<p class="yx-color-text-regular font-h6-regular mt-4">手机号：{{ userInfo.mobile }}</p>
									<div class="mt-6">
										<span class="role-label ml-4" style="display: inline-block" v-for="(item, index) in tagList" :key="index">
											{{ item.name }}
										</span>
									</div>
								</div>
							</div>
							<div class="divided"></div>
							<div class="item" @click="userCenter">个人中心</div>
							<div class="divided"></div>
							<!-- <div class="item" @click="taskCenter">任务中心</div> -->
							<div class="divided"></div>
							<div class="item" @click="handleCommand('logout')">退出登录</div>
						</div>
					</transition>
				</div>
			</div>
		</div>
		<newHandGuide ref="newHandGuide" :isApi="false" />
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import mixin from '@/mixins';
import * as types from '@/store/mutation-types.js';
import { logout } from '@/api/user';
import TopMenu from '@/components/topMenu';
import switchView from '@/components/business/switchView';
import router, { resetRoute } from '@/router';
import { tzRoleType } from '@/utils/dataMap';
import { getDictDatas, DICT_TYPE } from '@/utils/dict';
import customerQr from '@/components/ui/customerQr';
import newHandGuide from './components/newHandGuide';
export default {
	name: 'ControlHeader',
	components: {
		TopMenu,
		switchView,
		customerQr,
		newHandGuide,
	},
	inject: ['reload'],
	mixins: [mixin],
	data() {
		return {
			pe_level: 0,
			isSwitch: false,
			imgapi: '',
			showPopper: false,
			// 字典
			versionClassDict: getDictDatas(DICT_TYPE.SYSTEM_VERSION_CLASS),
		};
	},
	computed: {
		...mapState(['vuex_userTypeList', 'vuex_userId', 'vuex_system_conf', 'vuex_sphExpoName']),
		...mapGetters(['accountInfo', 'tenantInfo']),
		userInfo() {
			return this.accountInfo || {};
		},
		tagList({ vuex_userTypeList }) {
			// return vuex_userTypeList.filter(v => v.type !== tzRoleType.id);
			return vuex_userTypeList;
		},
		curVersionClass() {
			return this.versionClassDict.find(item => item.value == this.tenantInfo.cssClass)?.cssClass || '';
		},
	},
	created() {
		this.imgapi = process.env.VUE_APP_JAVA_API_BASE;
	},
	methods: {
		async handleCommand(val) {
			// 点击退出栏退出
			val === 'logout' ? this.exit() : this.handleChangeRoleCommand(val);
		},
		async handleChangeRoleCommand(dataViewId) {
			this.$store.commit(types.DATA_VIEW_ID, dataViewId);
			this.reload();
		},
		async exit() {
			await logout();
			utils.clearData();
			resetRoute(router);
			// 登出之后回到登录页
			this.$router.replace('/login');
		},
		userCenter() {
			this.$router.push({
				path: '/personal/center',
			});
		},
		startLoading() {
			const loading = this.$loading({
				lock: true,
				text: '角色切换数据加载中',
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, .8)',
			});
			this.$store.commit(types.PAGE_LOADING, loading);
		},
		taskCenter() {
			this.$router.push({
				path: '/taskCenter',
			});
		},
		appEnter() {
			this.showPopper = true;
		},
		appLeave() {
			this.showPopper = false;
		},
		userEnter() {
			this.isSwitch = true;
		},
		userLeave() {
			this.isSwitch = false;
		},
		openGuide() {
			this.$refs.newHandGuide.show();
		},
	},
};
</script>

<style scoped lang="less">
.c-header {
	width: 100%;
	height: 64px;
	padding: 12px 24px;
	box-sizing: border-box;
	background: #ffffff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	> .left-label {
		display: flex;
		align-items: center;
		> .logo {
			position: relative;
			cursor: pointer;
		}
	}
	> .right-label {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		position: relative;
		height: 64px;
		.user-info-wrapper {
			display: flex;
			align-items: center;
			height: 100%;
			.dropdown {
				position: absolute;
				width: 280px;
				top: 60px;
				right: 0;
				z-index: 5000;
				box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
				font-size: 14px;
				color: #1d2129;
				.item {
					height: 40px;
					line-height: 40px;
					padding-left: 16px;
					margin: 6px 0;
					cursor: pointer;
					&:hover {
						color: @color-primary;
						background-color: fadeout(@color-primary, 90%);
					}
				}
				.divided {
					border-top: 1px solid #f0f1f5;
				}
			}
		}
		.app-enter {
			width: 82px;
			height: 32px;
			position: relative;
			border: 1px solid #ebeef5;
			border-radius: 16px;
			line-height: 32px;
			.app-dropdown {
				position: absolute;
				width: 248px;
				height: 248px;
				top: 38px;
				left: 0;
				z-index: 5000;
				box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
				text-align: center;
				img {
					width: 120px;
					height: 120px;
				}
			}
		}

		.user-info {
			display: flex;
			align-items: center;
			border-radius: 28px;
			padding: 8px 12px 8px 12px;
			.user-name {
				color: #86909d;
				cursor: pointer;
				display: flex;
				align-items: center;
				.name-box {
					display: flex;
					align-items: center;
					.name {
						color: #1d2129;
						max-width: 98px;
						display: inline-block;
						max-width: 126px;
						line-height: 1;
						font-size: 14px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						text-align: left;
					}
				}
			}
		}
	}
}
.upgradation {
	display: flex;
	align-items: center;
	justify-content: center;
	/* 矩形 */
	padding: 8px 12px;
	opacity: 0.9;
	font-size: 12px;
	background: #fff3e4;
	color: #944120;
	position: relative;
	.i-upgradation {
		margin-right: 2px;
		display: inline-block;
		width: 16px;
		height: 16px;
	}
	.bubble {
		position: absolute;
		top: -8px;
		right: 0;
	}
}
.version {
	display: flex;
	align-items: center;
	justify-content: center;
	/* 矩形 */
	padding: 8px 12px;
	opacity: 0.9;
	font-size: 12px;
	& i {
		margin-right: 2px;
		display: inline-block;
		width: 16px;
		height: 16px;
	}
}
.version-default {
	/* 超/灰/G1 */
	background: #f7f8fa;
	/* 超/灰/G8 */
	color: #4e596a;
	& i {
		background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAABPlBMVEUAAABZZHVcZneDkbRdZ3hqcY5aY3VscY5fZX5ja4ZOWWpPWWptcZNtcZJOWWpia4BcZXdOWGpeaHpOWWpTXm9OWGldZ3htco9PWWhvcpiAgKZucZVucZRnboVlboNscZJOWWprcJBOWWtrcY9qcI9gan1qcIxrcI1PWWpob4prcY5ob4hocIlfZ3tqcIpzdphPWGpmcINRWWpNWWZQWGhOWWphan7///9jbIBkbYFmboNfaXtuc5Fob4Znb4VtcpBfZ3pgaXxuc5Nsco1ibH9eZ3lcZndqcIlpcIdvc5VrcoxrcYvp6u7d3uRwc5b9/f34+PmanrGJj6BtdYjx8vTW2N7MztbFx9KtsL56gJl2fZNvdY9cZXfl5urj5OnS1NvP0dq9wMq4useqrruipraOk6eBh5yAhpp0eZV0eZTeo5WCAAAANXRSTlMA6ekH6R7+MhgQ9/Pw39/ewqCFgG5oQz4yJRT9+Pjt7OfY183Myru4r6ygln10YFRUUDwoIP1veKoAAAFwSURBVDjLzdHXVsJAEIDhVaoIgoIi2HvvLgNCCBAwgdCrCPb+/i/g7IbOgSsv/G+/zJzJWfKPck20mmTp9Xpnvy8YjcbmLZZIRCKRYDAapfO9bp5ockwgMvX5fNSySLo5+KimPl6c0pmpjs8h92nc76eU7ncOQEVsqx8LBCjm0tyg58pRU+yGsvgZOgfigGLIrTNOeha3NRwOU94su1DTUqVaQtS0+PDW/UC3w0eLABWBoSAIxTykuW+aCTZlZ4vDTwBVpoLyVYZcgfn6des37GxxKQPwoiiKfJ8GuFPRp69IK9MqG+Ugy41HgNdUCv2SdHKvCDhbLwO8S7iolpIkajknPV0IMvaZhxz6c0OSRHzNvk4VWVXVjzwAZH5EzEkGOlZTuLiQg/S3KIZCh2SoIwkXi4VaPYTt6chwByKOsmKxbfThdLsMseSGdwh53i3OSZuBjMhsSyazWauJjMyzls0uu8mYTNalMzI2g4f8db/hfWxldiHsOgAAAABJRU5ErkJggg==');
		background-size: 16px 16px;
	}
}
.version-purple {
	/* 超/紫/P1 */
	background: #f0f5ff;
	/* 超/灰/G8 */
	color: @color-primary;
	& i {
		background: url('~@/assets/public/layout-blueDiamond-icon.png');
		background-size: 16px 16px;
	}
}
</style>
